
// Ensure smart-date-recognizer side-effects are loaded (registers window.recognizeDate / window.generateDatePatterns)
import '../../search/smart-date-recognizer/recognizer.js';
import '../../search/smart-date-pattern-generator.js';

import { FilterManager } from './manager-core.js';

// Export singleton instance and class
const filterManager = new FilterManager();

export { FilterManager, filterManager };


